import type { seoPageTypes } from 'BreetComponents';
import {
	isConversions,
	isEdits,
	isSells,
	isTopups,
	isWithdrawals,
	type ITransactionHistory,
	type TransactionHistoryType,
} from 'BreetHelpers';

export const getTransactionEditsType = (row: ITransactionHistory<TransactionHistoryType>) =>
	row.isCredit ? 'Admin Credit' : 'Admin Debit';

export interface IWalletFilterOption {
	label: string;
	value: string;
}

export const WALLET_STATUS_OPTIONS: IWalletFilterOption[] = [
	{ label: 'Completed', value: 'completed' },
	{ label: 'Pending', value: 'pending' },
	{ label: 'Processing', value: 'processing' },
	{ label: 'Reversed', value: 'reversed' },
	{ label: 'Flagged', value: 'flagged' },
	{ label: 'Rejected', value: 'rejected' },
];

export const getWalletTypeOptions = (onlyWithdrawals?: boolean): IWalletFilterOption[] =>
	onlyWithdrawals
		? [
				{ label: 'Withdrawals', value: 'withdrawals' },
				{ label: 'Conversions', value: 'conversions' },
			]
		: [
				{ label: 'Crypto Funding', value: 'sells' },
				{ label: 'Fiat Funding', value: 'topups' },
				{ label: 'Withdrawals', value: 'withdrawals' },
				{ label: 'Conversions', value: 'conversions' },
				{ label: 'Admin Action', value: 'edits' },
			];

export const currencyDisplayNames: Record<string, string> = {
	USD: 'USD',
	NGN: 'Naira',
	GHS: 'Cedis',
};

export interface ITableColumnDestination {
	row: ITransactionHistory<TransactionHistoryType>;
}

export interface ITableColumnType {
	row: ITransactionHistory<TransactionHistoryType>;
}

export interface ITableColumnTransactionDetails {
	row: ITransactionHistory<TransactionHistoryType>;
	onColumnClick?: () => void;
}

export interface IWalletTransactionProps {
	filterProps?: Record<string, string | boolean | number>;
	pageTitle: string;
	seoPage: seoPageTypes;
	hideWalletBalance?: boolean;
	hideNotification?: boolean;
	tip?: string;
	onlyWithdrawals?: boolean;
}

export const getTransactionType = (transaction: ITransactionHistory<TransactionHistoryType>): string => {
	if (isWithdrawals(transaction)) {
		return 'Withdrawals';
	}
	if (isConversions(transaction)) {
		return 'Conversions';
	}
	if (isEdits(transaction)) {
		return getTransactionEditsType(transaction);
	}
	if (isSells(transaction)) {
		return 'Crypto Funding';
	}
	if (isTopups(transaction)) {
		return 'Fiat Funding';
	}
	return '...';
};
